import { Tabs, TabsContent, TabsList, TabsTrigger } from '@sea-snag/ui';

import { IncomeComparison } from './income-comparison';
import { IncomeOverview } from './income-overview';

/** Analytics → Income (#217): Overview by default, and a read-only Year comparison. */
export function IncomePage({ orgPid, year }: { orgPid: string; year: number }) {
  return (
    <Tabs defaultValue="overview" className="space-y-4">
      <TabsList>
        <TabsTrigger value="overview">Overview</TabsTrigger>
        <TabsTrigger value="comparison">Year comparison</TabsTrigger>
      </TabsList>
      <TabsContent value="overview">
        <IncomeOverview orgPid={orgPid} year={year} />
      </TabsContent>
      <TabsContent value="comparison">
        <IncomeComparison key={year} orgPid={orgPid} year={year} />
      </TabsContent>
    </Tabs>
  );
}
